import { render, staticRenderFns } from "./spm-summary.vue?vue&type=template&id=54eadf74&"
import script from "./spm-summary.vue?vue&type=script&lang=js&"
export * from "./spm-summary.vue?vue&type=script&lang=js&"
import style0 from "./spm-summary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports